import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {
  async findAll ({ commit }) {
    const data = await axios({
      method: 'get',
      url: `${modulo.ARRECADACAO}/interessadosArrecadacao`
    })

    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/interessadoArrecadacao.js